import { TermsAndConditions } from '../common/components/TermsAndConditions';
import { OktaUserInfo } from '@/app/core/auth';
import { isAuthzAnyValue } from '@ascend/authz';
import {
  EnumTnCType,
  FeatureCodes,
  getSubCodesForProduct,
} from '@ssar-app/domain';
import { useCallback, FC, useMemo, useState } from 'react';
import { Modal } from '@ssar-app/uikit';
import { useHistory } from 'react-router-dom';
import { Text } from '@chakra-ui/react';

const defaultOnAccepted = () => Promise.resolve();

export const TermsAndConditionsWrapper: FC<{
  onAccepted?: () => Promise<void>;
}> = (props) => {
  const { children, onAccepted = defaultOnAccepted } = props;
  const [hasAccepted, setHasAccepted] = useState(false);
  const userProfile = OktaUserInfo.getOktaUserInfo();
  const history = useHistory();

  const onAcceptedLocal = useCallback(async () => {
    await onAccepted();
    setHasAccepted(true);
  }, [onAccepted]);

  const subCode = useMemo(() => {
    const subCodes = getSubCodesForProduct(
      FeatureCodes.AscendArchives,
      userProfile,
    );
    if (isAuthzAnyValue(subCodes)) {
      return '';
    } else {
      return subCodes.length > 0 ? (subCodes[0] as string) : '';
    }
  }, [userProfile]);

  return (
    <>
      {!hasAccepted && (
        <Modal
          isOpen
          closeOnEsc={false}
          closeOnOverlayClick={false}
          footer={null}
          showCloseButton={false}
          header={<Text>{'Terms & Conditions'}</Text>}
          showFooterBtns={false}
          contentProps={{ maxWidth: 'container.xl', mt: 20 }}
          onClose={() => null}
        >
          <TermsAndConditions
            type={EnumTnCType.LoginScreen}
            onAccept={onAcceptedLocal}
            subCode={subCode}
            onCancel={() => {
              history.replace('/logout');
            }}
          />
        </Modal>
      )}
      {hasAccepted && <>{children}</>}
    </>
  );
};
